import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import toast from 'react-hot-toast';
import { SILOREAL_SERVICE_META_SOURCE } from '@siloreal:shared:hooks/use-siloreal-service';

const FALLBACK_ERROR_MESSAGE = 'Ocurrió un error inesperado';

function extractErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data;

    if (typeof responseData === 'string' && responseData.trim()) {
      if (responseData.includes('Cannot GET /')) {
        return 'El servidor informa que no existe el servicio solicitado.';
      }
      return responseData;
    }

    if (responseData && typeof responseData === 'object') {
      const message = (responseData as { message?: unknown }).message;
      if (typeof message === 'string' && message.trim()) {
        return message;
      }
    }

    if (typeof error.message === 'string' && error.message.trim()) {
      // @ts-expect-error - A veces el mensaje de error de Axios es útil, otras veces no. Se intentará usar si es una cadena no vacía.
      return error.response.data.error;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return FALLBACK_ERROR_MESSAGE;
}

function shouldShowErrorToast(meta: unknown): boolean {
  if (!meta || typeof meta !== 'object') return false;

  const parsedMeta = meta as { source?: unknown; toastOnError?: unknown };
  return parsedMeta.source === SILOREAL_SERVICE_META_SOURCE && parsedMeta.toastOnError === true;
}

export const tanStackQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!shouldShowErrorToast(query.meta)) return;
      toast.error(extractErrorMessage(error));
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (!shouldShowErrorToast(mutation.options.meta)) return;
      toast.error(extractErrorMessage(error));
    },
  }),
});
